import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import rightArrowIcon from '../../images/rightArrowIcon.svg'
function AllInterviews(){
    const [interviews,setinterviews]=useState(null);
    const {state}=useLocation();
    const navigate=useNavigate();
    const{id}=useParams();
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        async function init(){
            try{
                setLoading(true);
                let storage=localStorage.getItem('storage');
                if(!storage){
                    navigate('/');
                }
                storage=await JSON.parse(storage);
                if(storage && storage.auth){
                    if(storage.user && storage.user.type==='Organizer'){
                        navigate('/org/hackathons/')
                    }
                    else if(storage.user && storage.user.type==='Recruiter'){
                        navigate('/recruiter/jobs/')
                    }
                    else{
                        if(storage.user && !storage.user.profileCompleted){
                            navigate('/user/profile/');
                        }
                        else{
                            if(state && state.interview){
                                let interview=state.interview;
                                for(let i=0;i<interview.length;i++){
                                    let future=new Date(interview[i].interviewdate).getTime()>new Date().getTime();
                                    interview[i]={...interview[i],future};
                                }
                                setinterviews(interview);
                            }
                            else{
                                const resp=await fetch(`${process.env.REACT_APP_BACKEND_URL}/job/applied/${id}`,{
                                    method:"POST",
                                    mode:"cors",
                                    headers:{
                                        "Content-Type": "application/json",
                                        "authToken":storage.auth
                                    }
                                })
                                const msg=await resp.json();
                                if(msg && msg.success){
                                    toast.success(msg.success,{
                                        toastId:"myinterviews"
                                    })
                                    let interview=msg.job.interview;
                                for(let i=0;i<interview.length;i++){
                                    let future=new Date(interview[i].interviewdate).getTime()>new Date().getTime();
                                    interview[i]={...interview[i],future};
                                }
                                    setinterviews(interview);
                                }
                                else if(msg && msg.error){
                                    throw msg.error;
                                }
                                else{
                                    throw "Some Error Occured";
                                }
                }
                }
            }
                }
                else{
                    navigate('/');
                }
            }
            catch(error){
                toast.error(error,{
                    toastId:"myassignmnets"
                });
            } finally {
                setLoading(false);
            }
        }
        init();
    },[])
    return(
        <div className="w-full h-full heading px-4 py-2 overflow-y-auto">
            {
                (!loading && interviews && interviews.length>0)?interviews.map((element,idx)=>(element.future)?<div className="rounded-lg px-4 py-3 my-2 flex justify-between items-center text-white heading bg-slate-400 hover:cursor-not-allowed" key={idx}>
                <div className='text-xl font-semibold'>
                    {element.interviewname}
                    <span className="text-sm bg-red-600 p-1 ml-2 rounded-full">Room Hasn't Started Yet</span>
                </div>
                <div>
                    <img src={rightArrowIcon} alt="icon"/>
                </div>
               
            </div>:<div className="rounded-lg px-4 py-3 my-2 flex justify-between items-center text-white heading bg-slate-600 hover:cursor-pointer" key={idx} onClick={()=>{navigate(`/interview/${id}/${element.roomId}`)}}>
                <div className='text-xl font-semibold'>
                    {element.interviewname}
                </div>
                <div>
                    <img src={rightArrowIcon} alt="icon"/>
                </div>
               
            </div>):<div className="w-full h-full flex justify-center items-center font-semibold">{loading ? "Loading..." : "No Interviews Available"}</div>
            }
        </div>
    )
}
export default AllInterviews;